import React, {useState} from "react";
import "./ClearDevices.css";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import {faTrashCan} from "@fortawesome/free-regular-svg-icons";

function ClearDevicesComponent({bond, reloadDevices}) {
    const [isClearing, setIsClearing] = useState(false);

    function clearDevices() {
        if (isClearing) return;
        if (!window.confirm("Delete ALL Devices?")) return;
        else setIsClearing(true);

        bond.get("/devices/").then((response) => {
            let devices = Object.keys(response);
            devices.splice(
                devices.findIndex((el) => el === "_"),
                1
            );
            removeDevices(devices);
        });
    }

    function removeDevices(devices) {
        let deviceId = devices.pop();
        if (deviceId !== undefined)
            bond.delete("/devices/" + deviceId).then((response) => {
                removeDevices(devices);
            });
        else {
            setIsClearing(false);
            reloadDevices();
        }
    }

    return (
        <Button
            className={"deviceManagerButton"}
            variant={"outline-danger"}
            disabled={isClearing}
            onClick={() => {
                clearDevices();
            }}
        >
            {isClearing ?
                <><FontAwesomeIcon icon={faSpinner} className={"fa-spin"}/> Deleting</> :
                <><FontAwesomeIcon icon={faTrashCan}/> Delete All</>
            }
        </Button>
    );
}

export default ClearDevicesComponent;
